import React from 'react';

import { PostOfficeSideNavMessageProvider } from '@post-office/placements--growth/confluence-side-nav/contexts/post-office-side-nav-message-provider';

import { NotesContextProvider } from '@confluence/notes-util/entry-points/NotesContext.tsx';
import { RightSidebarContextProvider } from '@confluence/page-layout-context';
import { InProductHelpProvider } from '@confluence/in-product-help/entry-points/InProductHelpProvider.ts';
import { fg } from '@confluence/feature-gating';
import { NthUserOnboardingFlag } from '@confluence/experiment-nth-user-getting-started-page/entry-points/NthUserOnboardingFlag.ts';

type PageLayoutContextProviderWrapperPropsType = {
	children: React.ReactNode;
};

export const PageLayoutContextProviderWrapper = ({
	children,
}: PageLayoutContextProviderWrapperPropsType) => {
	return (
		<RightSidebarContextProvider>
			<NotesContextProvider>
				<PostOfficeSideNavMessageProvider>
					<InProductHelpProvider>{children}</InProductHelpProvider>
					{fg('cc-engagement-getting-started-nth-user-gate') && <NthUserOnboardingFlag />}
				</PostOfficeSideNavMessageProvider>
			</NotesContextProvider>
		</RightSidebarContextProvider>
	);
};
